import uuid from "react-uuid";
import {Lang, Localised, LocalStorage} from "../types";

export const getWithDefault = (key: string, defaultValueFunc: ()=>string) => {
    let value = localStorage.getItem(key);

    if (!value || value.length === 0) {
        value = defaultValueFunc();
        localStorage.setItem(key, value);
    }

    return value;
};

export const getNextRandomLocalisedAndSaveAsUsed = (allElements:Localised<string>[], usedStorageName:string) => {
    const mapping = (el:Localised<string>):string => el[Lang.EN];
    return getNextRandomAndSaveAsUsed(allElements, usedStorageName, mapping);
};

export const getNextRandomAndSaveAsUsed = (allElements:any[], usedStorageName:string, filteringMapper:(el:any) => string) => {
    let used =  JSON.parse(localStorage.getItem(usedStorageName) || "[]");
    let unUsed = allElements.filter((el) => !used.includes(filteringMapper(el)));

    if (unUsed.length === 0) {
        unUsed = [...allElements];
        used = [];
    }

    const randomIndex = Math.floor(Math.random() * unUsed.length);
    const random = unUsed[randomIndex];

    localStorage.setItem(usedStorageName, JSON.stringify([...used, filteringMapper(random)]));

    return random;
};

export const getUserId = ():string => {
    return getWithDefault(LocalStorage.USER_ID_STORAGE, uuid);
};
